import { render, staticRenderFns } from "./EntranceExam.vue?vue&type=template&id=100406f4&scoped=true&"
import script from "./EntranceExam.vue?vue&type=script&lang=js&"
export * from "./EntranceExam.vue?vue&type=script&lang=js&"
import style0 from "./EntranceExam.vue?vue&type=style&index=0&id=100406f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100406f4",
  null
  
)

export default component.exports